var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.8713V14.8713C2.5 15.7013 3.17 16.3713 4 16.3713C4.83 16.3713 5.5 15.7013 5.5 14.8713V10.8713C5.5 10.0413 4.83 9.37125 4 9.37125C3.17 9.37125 2.5 10.0413 2.5 10.8713ZM8.5 10.8713V14.8713C8.5 15.7013 9.17 16.3713 10 16.3713C10.83 16.3713 11.5 15.7013 11.5 14.8713V10.8713C11.5 10.0413 10.83 9.37125 10 9.37125C9.17 9.37125 8.5 10.0413 8.5 10.8713ZM2 21.3713H18C18.83 21.3713 19.5 20.7013 19.5 19.8713C19.5 19.0413 18.83 18.3713 18 18.3713H2C1.17 18.3713 0.5 19.0413 0.5 19.8713C0.5 20.7013 1.17 21.3713 2 21.3713ZM14.5 10.8713V14.8713C14.5 15.7013 15.17 16.3713 16 16.3713C16.83 16.3713 17.5 15.7013 17.5 14.8713V10.8713C17.5 10.0413 16.83 9.37125 16 9.37125C15.17 9.37125 14.5 10.0413 14.5 10.8713ZM9.07 0.861254L1.17 5.02125C0.76 5.23125 0.5 5.66125 0.5 6.12125C0.5 6.81125 1.06 7.37125 1.75 7.37125H18.26C18.94 7.37125 19.5 6.81125 19.5 6.12125C19.5 5.66125 19.24 5.23125 18.83 5.02125L10.93 0.861254C10.35 0.551254 9.65 0.551254 9.07 0.861254Z",
    fill: "#610D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.9091a09c51bad92967b2bdcb5de35051.svg";
export { ForwardRef as ReactComponent };